function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2590",
  "data-name": "Group 2590",
  transform: "translate(-64.006 -758.893)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons-02-beauty-appearance",
  transform: "translate(23.577 742.349)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2568",
  "data-name": "Group 2568",
  transform: "translate(41.929 18.615)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2566",
  "data-name": "Group 2566",
  transform: "translate(13.109 24.446)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2565",
  "data-name": "Group 2565",
  transform: "translate(0 7.364)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3640",
  "data-name": "Path 3640",
  d: "M92.678,99.586s-.823,11.957.374,15.531a16.876,16.876,0,0,0,3.359,5.983",
  transform: "translate(-63.324 -87.121)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3641",
  "data-name": "Path 3641",
  d: "M61.53,115.205c2.223-4.027,0-16.429,0-16.429",
  transform: "translate(-58.256 -86.988)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3642",
  "data-name": "Path 3642",
  d: "M57.613,88.718c.627,3.135,2.077,5.378,3.274,7.742C64.425,103.393,69.071,106.9,74.1,106.9c4.882,0,9.383-3.162,12.863-9.767a123.174,123.174,0,0,0,5.586-12.465",
  transform: "translate(-57.613 -84.673)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_158",
  "data-name": "Ellipse 158",
  cx: 1.714,
  cy: 1.714,
  r: 1.714,
  transform: "translate(21.76 0.634)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_159",
  "data-name": "Ellipse 159",
  cx: 1.713,
  cy: 1.713,
  r: 1.713,
  transform: "translate(7.818 0.635)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3643",
  "data-name": "Path 3643",
  d: "M61.78,77.779c.7-.957,2.331-1.916,5.206-1.916s4.241.807,5.206,1.916",
  transform: "translate(-58.297 -75.863)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3644",
  "data-name": "Path 3644",
  d: "M80.478,77.779c.7-.957,2.329-1.916,5.206-1.916s4.236.807,5.206,1.916",
  transform: "translate(-61.367 -75.863)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3645",
  "data-name": "Path 3645",
  d: "M76.907,99.718c-2.281,0-3.9-2.075-4.358-2.594a18.157,18.157,0,0,1,2.787-.911c.486,0,.831.468,1.546.468.42,0,.808-.424,1.258-.419a23.871,23.871,0,0,1,3.026.863C80.711,97.642,79.3,99.718,76.907,99.718Z",
  transform: "translate(-60.065 -79.204)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3649",
  "data-name": "Path 3649",
  d: "M49.278,46.686s-7.349,9.63-7.349,25.379c0,13.288,10.457,26.24,10.457,26.24s.842-18.25,7.394-29.482A46.036,46.036,0,0,1,83.164,49.377a23.969,23.969,0,0,1,7.794,11.344c2.171,6.952-1.381,18.447-1.48,18.842s6.671-7.434,8.385-14.4c1.642-6.679,1.676-10.95-3.156-18.545",
  transform: "translate(-41.929 -46.615)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2584",
  "data-name": "Group 2584",
  transform: "translate(-463.33 770.802)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3719",
  "data-name": "Path 3719",
  d: "M574.33,69.62s5.291,5.3,10.934,0a8.182,8.182,0,0,1,10.934,0,7.784,7.784,0,0,0,10.934,0",
  transform: "translate(-2.012 -34.451)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3720",
  "data-name": "Path 3720",
  d: "M574.33,76.246s5.291,5.3,10.934,0a8.182,8.182,0,0,1,10.934,0,7.784,7.784,0,0,0,10.934,0",
  transform: "translate(-2.012 -35.517)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3721",
  "data-name": "Path 3721",
  d: "M574.33,82.9s5.291,5.3,10.934,0a8.182,8.182,0,0,1,10.934,0,7.785,7.785,0,0,0,10.934,0",
  transform: "translate(-2.012 -36.6)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_570",
  "data-name": "Line 570",
  y1: 1.895,
  x2: 1.789,
  transform: "translate(598.33 50.96)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3722",
  "data-name": "Path 3722",
  d: "M651.443,105.953v-4.945l1.895,1.895",
  transform: "translate(-51.324 -50.048)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_571",
  "data-name": "Line 571",
  x1: 1.789,
  y2: 1.895,
  transform: "translate(589.778 28.863)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3723",
  "data-name": "Path 3723",
  d: "M616.752,45.813v4.945l-1.895-1.895",
  transform: "translate(-26.974 -20)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_572",
  "data-name": "Line 572",
  y1: 1.895,
  x2: 1.789,
  transform: "translate(577.332 50.96)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3724",
  "data-name": "Path 3724",
  d: "M588.655,105.953v-4.945l1.895,1.895",
  transform: "translate(-9.534 -50.048)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
})));

var SvgElasticityIcon = function SvgElasticityIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79.905,
    height: 69.979,
    viewBox: "0 0 79.905 69.979",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgElasticityIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/elasticity-icon.c80bd731.svg";
export { ForwardRef as ReactComponent };